import { SystemStyleObject } from "@chakra-ui/react";

export const exportBtnCss: SystemStyleObject = {
  boxShadow: "0px 0px 0px 1px #122B6914",
  padding: "8px 16px",
  borderRadius: "8px",
  gap: "8px",
  display: "flex",
  alignItems: "center",
  height: "36px",
};

export const exportDropDownCss: SystemStyleObject = {
  width: "384px",
  height: "293px",
  backgroundColor: "#FFFFFF",
  border: "1px solid #F2F4F7",
  boxShadow: "0px 12px 16px -4px #10182814",
  borderRadius: "8px",
  padding: 0,
};

export const radioWrapper: SystemStyleObject = {
  "& input[type='radio']": {
    display: "none",
  },

  "& input[type='radio']:checked + .custom-radio-circle": {
    borderColor: "#00535C",
    backgroundColor: "#E5FDFF",
  },

  "& input[type='radio']:checked + .custom-radio-circle::after": {
    content: '""',
    width: "6px",
    height: "6px",
    backgroundColor: "#00535C",
    borderRadius: "50%",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
};

export const radioCircle: SystemStyleObject = {
  width: "16px",
  height: "16px",
  border: "1px solid #D0D5DD",
  borderRadius: "50%",
  display: "inline-block",
  marginRight: "8px",
  position: "relative",
};
